'use client';

import {
  useLayoutEffect,
  useState,
  type ReactNode,
  type RefObject,
} from 'react';
import { createPortal } from 'react-dom';
import { Position, useStore } from '@xyflow/react';
import { Box } from '@terra/ui-styled-system';
import {
  resolveAttackPathPagePopoverAnchor,
  type AttackPathPagePopoverAnchor,
} from './attack-path-page-popover-anchor.util';

type AttackPathNodePagePopoverProps = {
  anchorRef: RefObject<HTMLDivElement | null>;
  children: ReactNode;
};

export function AttackPathNodePagePopover({
  anchorRef,
  children,
}: AttackPathNodePagePopoverProps) {
  const viewportTransform = useStore((state) => state.transform);
  const [anchor, setAnchor] = useState<AttackPathPagePopoverAnchor | null>(
    null,
  );

  useLayoutEffect(() => {
    const element = anchorRef.current;

    if (!element) {
      return;
    }

    setAnchor(
      resolveAttackPathPagePopoverAnchor({
        nodeBounds: element.getBoundingClientRect(),
        viewport: { width: window.innerWidth, height: window.innerHeight },
      }),
    );
  }, [anchorRef, viewportTransform]);

  if (!anchor) {
    return null;
  }

  return createPortal(
    <Box
      position="fixed"
      zIndex="tooltip"
      style={{
        left: anchor.left,
        top: anchor.top,
        transform:
          anchor.position === Position.Top
            ? 'translate(-50%, -100%)'
            : 'translate(-50%, 0)',
      }}
    >
      {children}
    </Box>,
    document.body,
  );
}
